import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { SvgFilter, SecondaryBtn } from '@tmapy/style-guide';

const msg = defineMessages({
  label: {
    id: 'filterBtn.label',
    defaultMessage: 'Filtr',
  },
});

type FilterBtnProps = {
  isFiltered: boolean;
  onClick: () => void;
};

export const FilterBtn: React.FC<FilterBtnProps> = ({ isFiltered, onClick }) => {
  const filterIcon = {
    position: 'left' as const,
    element: <SvgFilter />,
    badge: isFiltered ? ('danger' as const) : undefined,
  };

  return (
    <SecondaryBtn icon={filterIcon} size="sml" onClick={onClick}>
      <FormattedMessage {...msg.label} />
    </SecondaryBtn>
  );
};
